import { ApiConversion, ApiProject } from "@incendium/api";
import { projectService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetchConversions = async (project: ApiProject) => {
  const conversions = await projectService.projectsServiceListProjectConversions({
    clientId: project.clientId as number,
    projectId: project.id as number,
  });
  return conversions.results || [];
};

export const useConversions = () => {
  const { state, setState, refetch, fetched } = useProjectSharedState<ApiConversion[]>(
    "conversions",
    [],
    fetchConversions
  );

  return {
    conversions: state,
    setConversions: setState,
    refetch: refetch,
    fetched,
  };
};
